export default __webpack_public_path__ + "static/hotblack-coffee-about3-c3d0ec62f4916fcc2e1e74e29bb469e7.png";